import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const Languages = () => {
  return (
    <Box>
        <Box sx= {{ margin: '20px 12px', color: '#FFFFFF' }}>
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 18}}>
                Programming Languages
            </Typography>
            <Divider sx={{ backgroundColor: '#FFFFFF', width: '30px', height: '2px' }} />
            {/* <Box sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                <ListItem sx={{ display: 'list-item'}}>
                    Web Application Development
                </ListItem>
            </Box> */}
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • Ruby
            </Typography>
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • JavaScript
            </Typography>
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • C++
            </Typography>
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • C#
            </Typography>
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • Python
            </Typography>
            <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
                • PHP
            </Typography>
        </Box>
    </Box>
  )
}

export default Languages